import { render, staticRenderFns } from "./SubmissionFormWarranty.vue?vue&type=template&id=19fc7572&scoped=true&"
import script from "./SubmissionFormWarranty.vue?vue&type=script&lang=ts&"
export * from "./SubmissionFormWarranty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fc7572",
  null
  
)

export default component.exports